import React from 'react';

const SignUp = (props) => {
    const setFieldHandler = event => {
        props.setField(event.target.name, event.target.value);
    }

    let logo = null;
    let h2Style = null;
    if (parseInt(props.signUpType) === 5) {
        logo = (
            <div className="logo utp-logo">
                <img src="https://ac-ut-health.s3.amazonaws.com/utp-logo.png" alt="UTP" />
            </div>
        );
        h2Style = { paddingTop: 'calc((100vh - 567px) / 2)' };
    } else if (parseInt(props.signUpType) === 6) {
        logo = (
            <div className="logo uth-logo">
                <img src="https://ac-ut-health.s3.amazonaws.com/uth-logo-02-08-2022.png" alt="UTH" />
            </div>
        );
        h2Style = { paddingTop: 'calc((100vh - 640px) / 2)' };
    }    

    return (
        <div className="sign-up-container">
            <h2 style={h2Style}>Sign Up</h2>
            <div className="sign-up-form">
                {logo}
                <div className="field">
                    <div>Name <span className="required">*</span>:</div>
                    <input type="text" name="name" value={props.form.name} onChange={setFieldHandler} />
                </div>
                <div className="field">
                    <div>Email <span className="required">*</span>:</div>
                    <input type="text" name="email" value={props.form.email} onChange={setFieldHandler} />
                </div>
                <div className="field">
                    <div>Confirm Email <span className="required">*</span>:</div>
                    <input type="text" name="confirmEmail" value={props.form.confirmEmail} onChange={setFieldHandler} />
                </div>
                <div className="field">
                    <div>Phone <span className="required">*</span>:</div>
                    <input type="text" name="phone" value={props.form.phone} onChange={setFieldHandler} />
                </div>
                <div className="field">
                    <div>Password <span className="required">*</span>:</div>
                    <input type="password" name="password" value={props.form.password} onChange={setFieldHandler} />
                </div>
                <div className="field">
                    <div>Confirm Password <span className="required">*</span>:</div>
                    <input type="password" name="confirmPassword" value={props.form.confirmPassword} onChange={setFieldHandler} />
                </div>
                <div className="buttons-container text-right">
                    <button
                        className="cancel-button"
                        type="button"
                        onClick={props.setSignUp.bind(this, null)}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={props.signUp}
                        disabled={props.signingUp}
                    >
                        {props.signingUp ? <i className="fas fa-circle-notch fa-spin"></i> : 'Sign Up'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SignUp;
